import * as Yup from "yup";

export const researchAreaSchema = Yup.object().shape({
  name: Yup.string().required("Research area name is required"),
  description: Yup.string().nullable(),
});
